import { render } from "./admin-menu.vue?vue&type=template&id=abafb260&scoped=true"
import script from "./admin-menu.vue?vue&type=script&lang=js"
export * from "./admin-menu.vue?vue&type=script&lang=js"

import "./admin-menu.vue?vue&type=style&index=0&id=abafb260&lang=scss&scoped=true"

import exportComponent from "/home/gebruiker/www/fresh/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abafb260"]])

export default __exports__